import { REVIEW_POLL_INTERVAL_MS } from '@omnea-app/fe-requests/document-review/useGetDocumentReview'
import { isReviewInFlight, type RequestDocumentReviewStatus } from './reviewStatus'

export const inFlightReviewRefetchInterval = (
  documents: { reviewStatus?: RequestDocumentReviewStatus }[] | undefined
): number | false => (documents?.some((document) => isReviewInFlight(document.reviewStatus)) ? REVIEW_POLL_INTERVAL_MS : false)

export const combineRefetchIntervals = (...intervalResults: (number | false)[]): number | false => {
  const activeIntervals = intervalResults.filter((interval): interval is number => interval !== false)
  return activeIntervals.length > 0 ? Math.min(...activeIntervals) : false
}
